/* s1-fabric: lazy ambience video.
   The band's <video> ships without src/autoplay (see the section comment) so
   its multi-MB source can't compete with first paint. When the band nears the
   viewport the data-src is attached and playback starts muted — visually the
   same as autoplay — and it pauses again off screen to save CPU/battery. */
const io = new IntersectionObserver((entries) => {
  for (const entry of entries) {
    const v = entry.target;
    if (entry.isIntersecting) {
      if (!v.src && v.dataset.src) v.src = v.dataset.src;
      v.play().catch(() => {});
    } else if (!v.paused) {
      v.pause();
    }
  }
}, { rootMargin: '200px' });

const observeAll = () => {
  document.querySelectorAll('[data-s1-fabric-video]').forEach((v) => io.observe(v));
};
observeAll();
/* theme editor re-renders swap the section's DOM without re-running modules */
document.addEventListener('shopify:section:load', observeAll);
